const fourSumWithHashing = (arr, sum, n = arr.length) => {
  // hashmap
  const map = new Map();

  for (let i = 0; i < n - 1; i++) {
    for (let j = i + 1; j < n; j++) {
      // calc pending target sum
      let val = sum - (arr[i] + arr[j]);

      // if pending target is present in the map,
      // then there can be a quadruplet
      if (map.has(val)) {
        // get all quadruplets whose indexes are not overlapping
        for (let entries of map.get(val)) {
          let { x, y } = entries;
          // if Quadruplet don't overlap return true
          if (x !== i && x !== j && y !== i && y !== j) {
            return true;
          }
        }
      }

      // add current pair
      if (!map.has(arr[i] + arr[j])) {
        map.set(arr[i] + arr[j], []);
      }

      map.get(arr[i] + arr[j]).push({ x: i, y: j });
    }
  }

  //return false
  return false;
};

export default fourSumWithHashing;
